<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Home'"> Welcome to the Panoptyc LP Portal!</app-pan-card>
